import Handlebars from "utilities/vendor/handlebars/4.7.9/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.9/js/handlebars";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import jQuery from "utilities/vendor/jquery/3.7.1/js/jquery";
import $ from "utilities/vendor/jquery/3.7.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.9/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.9/js/handlebars.runtime";
/**
 * State utilities
 */

export default {

  /**
   * @method disableModule
   */
  disableModule () {
    this.$target.addClass('hide');
  },

  /**
   * @method enableModule
   */
  enableModule () {
    this.$target.removeClass('hide');
  },

  /**
   * @method fadeOutModule
   */
  fadeOutModule() {

    // fade out
    this.$target.fadeOut(1000);

    // add class
    this.$target.removeClass('todo-active');
  },

  /**
   * @method formatPricce
   * @param  {Number} amountBorrowed
   */
  formatPrice (amountBorrowed) {

    // get amount
    var dollarFormat = amountBorrowed.toString().split('.');

    // if length is greater than 5
    if (dollarFormat[0].length >= 5) {
      dollarFormat[0] = dollarFormat[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }

    // if length is greater than 5
    if (dollarFormat[1] && dollarFormat[1].length >= 5) {
      dollarFormat[1] = dollarFormat[1].replace(/(\d{3})/g, '$1 ');
    }

    // return dollar format
    return dollarFormat.join('.');

  },

  /**
   * @method formatZip
   * @param zipCode
   * @returns {string}
   */
  formatZip (zipCode){

    // if undefined show empty string
    if (zipCode === undefined) {
      zipCode = '';
    }

    // strip anything but the 5 values for zip
    var zipFormat = zipCode.slice(0, 5);

    // strip anything but characters, and leave numbers
    return zipFormat.replace(/[^0-9]/g, '');

  },

  /**
   * @method bindAllMethods
   * @desc Utility method to not have to bind all methods
   */
  bindAllMethod () {

    // lets get modules prototype
    let methods = Object.getOwnPropertyNames(Object.getPrototypeOf(this));

    // bind all methods with this
    let loopThroughMethods = method => {
      this[method] = this[method].bind(this);
    };

    // remove init & constructor methods
    methods = methods.slice(1, -1);

    // loop through methods
    methods.forEach(loopThroughMethods);

  },

  /**
   * @method dropdownToggle
   * @desc Returns a function that handles dropdown animation
   */
  dropdownToggle ($dropdown, $arrow) {

    return () => {

      // slide Toggle of dropdown Contact-us menu
      $dropdown.slideToggle('slow');

      // toggle class of rotate, so that chevron rotates correct direction
      $arrow.toggleClass('rotate-up rotate-down');

    };

  },

  /**
   * @method getQueryParamValues
   * @param url - a URL to attempt to parse query parameters from
   * @desc attempt to parse query parameters from a URL
   */
  getQueryParamValues(url) {
    const pattern = /([^\/\?\&\=]+\=[^\&\#]+)/g;
    const matches = url.match(pattern);
    return matches && _.fromPairs(matches.map(pair => pair.split('=').map(encodeURIComponent)));
  },

  /**
  * @method inputRemovePatternDataAttr
  * @param selector
  * desc - removes input data-default-pattern and pattern attributes and adds a
  * match on anything that fixes a parsley issue with sparta inputs >=v5
  */
  inputRemovePatternDataAttr (selector) {
    let $selector = $ (selector );
    $selector.find('input').each(function(idx, val){
      let $val = $(val);
      $val.removeAttr('data-default-pattern').attr('data-default-pattern', '.*').removeAttr('pattern');
    });

  },

  /**
   * @method updatePartial
   * @param state
   * @param partialId
   * @param elementClass
   */
  updatePartial ( state, partialId, elementClass, helpers = null ) {

      // cache selector
      const $partial = $( partialId );

      // partial doesn't exist stop updating
      if ( !$partial.length ) {
          return false;
      }

      // cache html inside of selector
      const html = $partial.html();

      if (helpers) {
        for (let helper in helpers) {
                if (helpers.hasOwnProperty(helper)) {
                    hbs.registerHelper(helper, helpers[helper]);
                }
        }
      }

      // create handlebars template
      const hbsTemplate = hbs.compile( html );

      // cache template
      const source = hbsTemplate( state );

      // add hbs to dom
      $( elementClass ).html( source );

  },

  /**
   * @method spartaInputHack
   * @param $target - a jQuery object to search for sparta global inputs
   *
   * @desc remove duplicate elements introduced by sparta global input help
   */
  spartaInputHack($target) {
    const fix = () => {
      $target.find('.spa-input').each(function () {
        const $duplicateDropdowns = $(this).siblings('.input-help:not(:first)');
        $duplicateDropdowns.remove();
        const $duplicateTriggers = $(this).children('.toggle-trigger:not(:last)');
        $duplicateTriggers.remove();
      });
    };
    setTimeout(fix, 2000);
  },

  /**
   * @method toTitleCase
   * @param {String} words - a string to convert to title client-name-secure-home-loans
   * @desc convert a string to title case
   */
  toTitleCase(words) {
    return words.split(' ').map((word) => word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  },

  /**
   * @method caseWord
   * @param {String} str
   */
  caseWord (str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },

  /**
   * @method replaceTokens
   * @param {Object} element - the element to search for tokens
   * @param {Object} context - an object containing the replacement values
   * @desc replace token values with dynamic data
   */
  replaceTokens($element, context) {
    const traverseTo = (o, path) => {
      return _.reduce(path, (memo, segment) => memo && memo[segment], o);
    }
    const formatValue = (value, type = 'string') => {
      switch (type) {
        case 'currency':
          const formatted = value && (new Number(value)).toLocaleString();
          return `\$${formatted || 'XXX,XXX'}`;
        case 'date':
          // @todo: format date values
          return value ? value : (new Date()).toLocaleDateString();
        case 'percentage':
          return `${value ? (new Number(value)).toFixed(3) : 'X.XXX'}%`;
        case 'zipcode':
          return value ? value.slice(0, 5) : 'XXXXX';
        default:
          return value;
      }
    }
    const $tokens = $element.find('.convert');
    $tokens.each(function () {
      const $token = $(this);
      const key = $token.data('token');
      if (key) {
        const value = traverseTo(context, key.split('.'));
        const formatted = formatValue(value, $token.data('type'));
        if (formatted || formatted === 0) {
          $token.html(formatted);
        }
      }
    });
  },

  /**
   * @method registerHandlebarsHelpers
   * @param {Handlebars} handlebars - an instance of handlebars
   * @param {Object} helpers - an object with methods that follow the handlebars helper convention
   * @desc register helpers with an instance of handlebars
   */
  registerHandlebarsHelpers(handlebars, helpers) {
    for (var helper in helpers) {
      if (helpers.hasOwnProperty(helper)) {
        handlebars.registerHelper(helper, helpers[helper]);
      }
    }
  },

  render($elements, context, handlebars, renderedList) {
    $elements.each(function () {
      const $instance = $(this);
      const id = $instance.attr('id');
      if (!renderedList[id]) {
        renderedList[id] = true;
        const template = $instance.html();
        const templateFunction = handlebars.compile(template);
        const html = templateFunction(context);
        $instance.html(html);
      }
    });
  },

  toggleContent($elements, condition) {
    if (condition) {
      $elements.show();
    } else {
      $elements.hide();
    }
  },

  /**
   * this is a real douzie of functional composition
   * give it a list of strings ('.some-class','#someId', jQuery elements or both
   * the first arg can optionally be 'show' or 'hide' all elems depending on what you want to do.  Default, it will .toggle()
   * bonus: if you give it 'hideandclear' and it will clean inputs after that
   * it can handle elements that have either a declared visibility, display or opacity and toggle it properly per element
   * the last argument can be a callback
   **/
  moduleToggler(...toggleObj){
    const self = this;
    let $el;
    let currentShowObj;
    let len = toggleObj.length - 1;
    let command = (typeof toggleObj[0] === 'string' && (toggleObj[0] === 'show' || toggleObj[0].indexOf('hide') !== -1)) ? toggleObj[0] : undefined;

    $.fn.toggleAll = function (command) {
      $el = $(this);
      const visible = () => {
        return $el.css('visibility') !== 'hidden';
      };
      const displayed = () => {
        return $el.css('display') !== 'none';
      };
      const opaque = () => {
        return $el.css('opacity') !== '0';
      };
      if (displayed() && visible() && !opaque()) {
        $el.css({'opacity': '1'});
      } else if (displayed() && opaque() && !visible()) {
        $el.css({'visibility': 'show'});
      } else {
        if (command && command.indexOf('hide') !== -1) {
          $el.hide();
          if (command.indexOf('andclear' !== -1)) {
            self.clearInputs($el);
          }
        } else if (command && command === 'show') {
          $el.show();
        } else {
          $el.toggle();
        }
      }
    };

    toggleObj.map((obj, i) => {
      if (typeof obj !== "function") {
        currentShowObj = obj;
        this.getParentModule(obj).toggleAll(command);
      } else if (i === len) {  // this is the last argument
        if (obj.Events && typeof obj.Events === 'object' && Object.keys(obj.Events._store).length >= 0) {
          // publish an event saying to hide things and give the module that is being shown
          obj.Events.pub('module-toggler-called', currentShowObj);
        } else {
          obj($el);  // perform the callback
        }
      }
    });
  },

  clearInputs($el) {
    const moduleInputs = $el.find(':input');
    moduleInputs.map((i, obj) => {
      //dont remove value of radio buttons just uncheck them
      if(obj.type === "radio"){
        $(obj).prop('checked', false);
      }else{
        $(obj).val("");
      }
    });
  },
  //
  // ////pass param so as not to affect anything else using this function to  keep value of radio just uncheck them
  // clearInputs($el, keepRadioValues) {
  //   const moduleInputs = $el.find(':input');
  //   moduleInputs.map((i, obj) =>
  //     if(keepRadioValues) {
  //       if(obj.type === "radio"){
  //         $(obj).prop('checked', false);
  //       }else{
  //         $(obj).val("");
  //       }
  //     } else {
  //       $(obj).val("");
  //       $(obj).prop('checked', false);
  //     }
  //
  //   });
  //
  // },


  isJqueryEl(el) {  // Boolean.  Answers the Q of is this a jQuery element
    return ('jquery' in Object(el)) ? true : false;
  },

  isPlainArray(el) {  // Boolean.  Answers the Q of is this a plain array/indexed object
    return (el && el.constructor === Array && !this.isJqueryEl(el)) ? true : false;
  },

  isSpartaModule(el) {  // Boolean.  Answers the Q of is the selected element a Sparta module
    return (this.isJqueryEl(el) && typeof el.attr('data-component') === "module") ? true : false;
  },

  getParentModule(el) {  // get parent module element of whatever element you've working with
    if (!this.isSpartaModule(el)) {
      if (!this.isJqueryEl(el)) {
        el = $(el);
      }
      el = el && el.closest('div[data-component="module"]')
    }
    return el;
  },

  lowerTrimString(key) {  // e.g. ' Blah Blah YAda' -> 'blahblahyada'
    return key.split(' ').join('').toLowerCase();
  },

  lowerTrimObjectKeys(obj) {  // turns all object keys into lowercase, trimmed keys.  You're welcome.
    return Object.assign(
      {},
      ...Object.keys(obj).map(key => ( {[this.lowerTrimString(key)]: obj[key]}))
    );
  },
  arrayDiff(a, b) {  // give back an array of the non-matches
    const diffIndexes = [];
    return b.filter(function (i) {
      if (a.indexOf(i) < 0) {
        diffIndexes.push(b.indexOf(i));
        return true;
      } else {
        return false;
      }
    });
  },

  handlebarsHelpers: {
    eq: (left, right, options) => {
      return left === right ? options.fn(this) : options.inverse(this);
    },
    currency: (value) => {
      const numericValue = new Number(value);
      if (numericValue < 1) {
        return value;
      }

      let formatted = (value || value === 0) && (new Number(value)).toFixed(2).replace(/./g, function (character, index, amount) {
          return index && character !== "." && ((amount.length - index) % 3 === 0) ? ',' + character : character;
        });

      return `\$${formatted || 'XXX,XXX'}`;
    },
    currencyRoundedInt: (value) => {
      const numericValue = new Number(value);
      if (numericValue < 1) {
        return value;
      }

      let formatted = (value || value === 0) && (new Number(value)).toFixed().replace(/./g, function (character, index, amount) {
          return index && character !== "." && ((amount.length - index) % 3 === 0) ? ',' + character : character;
        });

      return `\$${formatted || 'XXX,XXX'}`;
    },
    date: (value) => {
      return value ? value : (new Date()).toLocaleDateString();
    },
    percentage: (value) => {
      return `${value ? (new Number(value)).toFixed(3) : 'X.XXX'}%`;
    },
    zipcode: (value) => {
      return value ? value.slice(0, 5) : 'XXXXX';
    },
    getCustomFormattedDate: (value, monthDay, dayMonth) => {
      let pad = '00';
      let dt = new Date(value);
      let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let day = '' + dt.getDate();
      day = pad.substring(0, pad.length - day.length) + day;
      let month = monthNames[dt.getMonth()];
      let year = dt.getFullYear();
      let hour = dt.getHours() % 12;
      hour = hour ? '' + hour : '12';
      hour = pad.substring(0, pad.length - hour.length) + hour;
      let min = '' + dt.getMinutes();
      min = pad.substring(0, pad.length - min.length) + min;
      let amPM = 12 - dt.getHours() > 0 ? 'am' : 'pm';
      let timeZone = dt.toString().match(/(\()(.*)(\))/)[2];
      let spanish = /\/es/.test(window.location.pathname);
      if (spanish){
        let mappings = {'eastern': 'hora del este', 'pacific': 'tiempo de pacifico',
                       'central' : 'hora del centro', 'mountain': 'hora de la montaña',
                       'hawaii': 'hora del Hawaii' };

        for(let key in mappings){
          if (timeZone.toLowerCase().includes(key)){
            timeZone = mappings[key];
            break;
          }
        }

      }
      if (monthDay){
        return `${month} ${day} ${year} ${hour}:${min} ${amPM} ${timeZone}`;
      }
      else if (dayMonth){
        return `${day} ${month} ${year} ${hour}:${min} ${amPM} ${timeZone}`;
      }
      else{
        return `${day} ${month} ${year} ${hour}:${min} ${amPM} ${timeZone}`;
      }

    }
  }

}


